import axios from 'axios';

export async function downloadPDF(payload, type, file_name, download_type = true) {
    try {
        const pdfmake_ip = process.env.VUE_APP_PDFMAKE_URL;

        const response = await axios.post(`${pdfmake_ip}/generate-pdf/${type}`, payload, {
            responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });

        if (download_type) {
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = file_name;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(blobUrl);
        }
        return blob
    } catch (error) {
        console.error('Error generating or downloading the MA PDF:', error);
    }
}
